import { cv } from "@suse-o11y/class-variance";
import { Tabs as AntdTabs, type TabsProps as AntdTabsProps } from "antd/es";
import React from "react";

import styles from "./_tabs.module.css";

export type TabProps = React.PropsWithChildren<{
	className?: string;
	key: React.Key;
	tab: React.ReactNode;
	disabled?: boolean;
}>;

export const Tab: React.FC<TabProps> = (props) => <AntdTabs.TabPane {...props} />;

export type TabTypes = "line" | "card";

export type TabsOverflow = "auto" | "visible";

const variants = cv(styles.tabs, {
	variants: {
		overflow: {
			auto: styles.auto,
			visible: styles.visible,
		},
	},

	defaultVariants: {
		overflow: "auto",
	},
});

export type TabsProps<TKey extends string = string> = React.PropsWithChildren<{
	className?: string;
	style?: React.CSSProperties;
	type?: TabTypes;
	/**
	 * @default "auto"
	 */
	overflow?: TabsOverflow;
	tabBarExtraContent?: React.ReactNode;
	tabBarStyle?: React.CSSProperties;
	activeKey?: TKey;
	destroyInactiveTabPane?: boolean;
	onChange?(key: TKey): void;
	renderTabBar?: AntdTabsProps["renderTabBar"];
}>;

export const Tabs = <TKey extends string = string>({ className, overflow = "auto", ...props }: TabsProps<TKey>) => (
	<AntdTabs {...props} className={variants({ overflow, className })} />
);
